import React from 'react';
import {
  Card, Skeleton, SkeletonBlock, SkeletonContent, SkeletonLine
} from '@one-thd/sui-atomic-components';

const RelatedProductsPlaceholder = () => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      <SkeletonLine variant="heading" />
      <div className="sui-grid xl:sui-grid-cols-6 lg:sui-grid-cols-4 md:sui-grid-cols-4 sui-grid-cols-2 sui-gap-6">
        {Array(4).fill('').map((__, index) => (
          <Card key={index} className="sui-w-full" disablePadding>
            <Skeleton grow key={index} orientation="vertical">
              <SkeletonContent density="loose" disablePadding initialSize="2/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="2/4">
                <SkeletonLine numberOfLines={3} />
              </SkeletonContent>
            </Skeleton>
          </Card>
        ))}
      </div>
    </div>
  );
};

RelatedProductsPlaceholder.displayName = 'RelatedProductsPlaceholder';

export { RelatedProductsPlaceholder };